import { flow } from 'lodash-es';
import type { ReactNode } from 'react';
import { Component } from 'react';

import { Icon } from '@mui/material';

import notFoundImg from 'img/logos/404_icon.svg';

import withTranslate from 'common/i18n/i18n';
import type { EnhancedRoutingProps } from 'common/utils/withEnhancedRouting';
import { withEnhancedRouting } from 'common/utils/withEnhancedRouting';
import { CISecondaryButton } from 'common/viewcomp/forms/buttons';
import { withAuthLayout } from 'module/auth/login/authLayout.page';

import './studydeleted.scss';

interface Props extends EnhancedRoutingProps {
    t: Function;
}

export class StudyDeletedComponent extends Component<Props> {
    public constructor(props: Props) {
        super(props);
        this.backtoLogin = this.backtoLogin.bind(this);
    }

    private backtoLogin(): void {
        this.props.navigate('/');
    }
    /**
     * Render component to screen
     */
    public render(): ReactNode {
        const t = this.props.t;

        return (
            <div id="study_not_found">
                <Icon>
                    <img src={notFoundImg} alt="" />
                </Icon>
                <p>{t('study_not_found.study_deleted')}</p>
                <p>{t('study_not_found.contact_support')}</p>
                <CISecondaryButton className="back_login" type="submit" id="back_login" onClick={this.backtoLogin}>
                    {t('study_not_found.back_login')}
                </CISecondaryButton>
            </div>
        );
    }
}

const StudyDeleted = flow([withAuthLayout, withTranslate('global'), withEnhancedRouting])(StudyDeletedComponent);

export default StudyDeleted;
